/* Abbyson – Reviews page room filter.
   Fully static: cards carry data-rooms, tabs carry data-filter. A tab with an
   empty data-filter shows everything. */
(function () {
  'use strict';

  class AbbysonRoomFilter extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-ar-tab]'));
      this.cards = Array.from(this.querySelectorAll('[data-ar-card]'));
      this.empty = this.querySelector('[data-ar-empty]');

      if (!this.tabs.length || !this.cards.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.apply(tab));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
      });

      const active = this.tabs.find((tab) => tab.getAttribute('aria-pressed') === 'true');
      this.apply(active || this.tabs[0]);
    }

    onKeydown(event, tab) {
      const index = this.tabs.indexOf(tab);
      let next = null;
      if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
      if (next === null) return;
      event.preventDefault();
      this.apply(this.tabs[next]);
      this.tabs[next].focus();
    }

    apply(tab) {
      if (!tab) return;
      const filter = (tab.dataset.filter || '').trim();

      this.tabs.forEach((item) => {
        const on = item === tab;
        item.setAttribute('aria-pressed', on ? 'true' : 'false');
        item.setAttribute('tabindex', on ? '0' : '-1');
      });

      let shown = 0;
      const limit = parseInt(this.dataset.limit || '0', 10);

      this.cards.forEach((card) => {
        const rooms = (card.dataset.rooms || '').split(' ').filter(Boolean);
        let match = filter === '' || rooms.indexOf(filter) > -1;
        if (match && limit > 0 && shown >= limit) match = false;
        card.classList.toggle('is-hidden', !match);
        if (match) shown += 1;
      });

      if (this.empty) this.empty.hidden = shown > 0;
    }
  }

  if (!customElements.get('abbyson-room-filter')) {
    customElements.define('abbyson-room-filter', AbbysonRoomFilter);
  }
})();